import styled from 'styled-components'

export const StyledIcon = styled.div``

export const ChristmasToyStyled = styled.img`
  padding-left: 8px;
  width: 24px;
  height: 16px;
`
